import { action } from 'satcheljs';

/**
 * Action to set FolderId and folder Display name in search store
 * WI #87447 : Remove this action once UnifiedSearch is rolled out to 100%
 */
export default action(
    'setStaticFolderScopeId',
    function setStaticFolderScopeId(folderId: string, isAllFolder: boolean = false) {
        return { folderId, isAllFolder };
    }
);
